export default __webpack_public_path__ + "static/media/help-rav-inv-10.dd7e9483.png";